import { Button, Descriptions, Dropdown, Popconfirm, Space } from "antd";
import { useNavigate, useParams, useRouteLoaderData } from "react-router";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import BackTitle from "../common/BackTitle";
import { api } from "../common/api";

export default function AbsenceType() {
  const navigate = useNavigate();
  const data = useRouteLoaderData("absenceType");
  const { id } = useParams();

  const items = [
    {
      key: "name",
      label: "Nome",
      children: data.name,
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <BackTitle
        backEnabled={false}
        title="Dettagli categoria assenza"
        secondary={`ID: ${id}`}
        extra={
          <Space size={4}>
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  {
                    key: "deleteAbsenceType",
                    label: (
                      <Popconfirm
                        title="Conferma rimozione"
                        onConfirm={() => api.absenceType.delete(id).then(() => navigate(".."))}
                        description="L'operazione è irreversibile. Procedendo, i dati verranno rimossi definitivamente."
                      >
                        Elimina
                      </Popconfirm>
                    ),
                    danger: true,
                    icon: <DeleteOutlined />,
                  },
                ].filter((x) => !!x),
              }}
            >
              <Button icon={<MoreOutlined />} />
            </Dropdown>
          </Space>
        }
      />
      <Descriptions
        layout="vertical"
        title={
          <>
            Informazioni generali
            <Button type="link" icon={<EditOutlined />} onClick={() => navigate("edit")} />
          </>
        }
        column={3}
        colon={false}
        items={items}
      />
    </div>
  );
}
